import React from 'react'
import 'assets/iconfont/iconfont.css'
import 'assets/scss/app.scss'
import useEagerConnect from 'hooks/useEagerConnect'
import routers from "routers/index"
import { Route, Router } from "react-router-dom"
import history from 'routerHistory'
import BigNumber from 'bignumber.js'
import { useFetchProfile } from 'state/hooks'

BigNumber.set({ 
    EXPONENTIAL_AT: 1000,
    DECIMAL_PLACES: 80,
    ROUNDING_MODE: BigNumber.ROUND_DOWN
   }) 

const App: React.FC = () => {
    useEagerConnect()
    useFetchProfile()
    
    return (
        <Router history={history}>
            {
                routers.map(router => {
                    return (
                        <Route
                            key={router.path}
                            path={router.path}
                            exact={router.exact}
                            component={router.component}
                        ></Route>
                    )
                })
            }
        </Router>
    );
}

export default React.memo(App);
